/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { GPDIds } from "./GPDIds";
import { GPDIdsFromJSON, GPDIdsFromJSONTyped, GPDIdsToJSON, GPDIdsToJSONTyped } from "./GPDIds";

/**
 *
 * @export
 * @interface ApiGpdIdsList200Response
 */
export interface ApiGpdIdsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGpdIdsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGpdIdsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGpdIdsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<GPDIds>}
   * @memberof ApiGpdIdsList200Response
   */
  results: Array<GPDIds>;
}

/**
 * Check if a given object implements the ApiGpdIdsList200Response interface.
 */
export function instanceOfApiGpdIdsList200Response(
  value: object
): value is ApiGpdIdsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGpdIdsList200ResponseFromJSON(json: any): ApiGpdIdsList200Response {
  return ApiGpdIdsList200ResponseFromJSONTyped(json, false);
}

export function ApiGpdIdsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGpdIdsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(GPDIdsFromJSON),
  };
}

export function ApiGpdIdsList200ResponseToJSON(json: any): ApiGpdIdsList200Response {
  return ApiGpdIdsList200ResponseToJSONTyped(json, false);
}

export function ApiGpdIdsList200ResponseToJSONTyped(
  value?: ApiGpdIdsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(GPDIdsToJSON),
  };
}
